/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import { Button, CircularProgress, Collapse, IconButton, Paper, Slider, Table, TableBody, TableCell, TableContainer, TableHead, 
    TableRow, Typography, FormControl, InputLabel, Select, MenuItem, Switch, TextField, ButtonGroup } from '@material-ui/core'

import { format } from 'date-fns'

import Actions from '../../fluid/Actions/ActionFactory'

import TrainingStage from '../IC/components/Operation/TrainingStage';
import Report from './Report/Report'
import { Clear, SignalCellularNullOutlined } from '@material-ui/icons';


const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    headerStyle : {
        color : '#707070',
        backgroundColor : 'rgba(245,245,245,0)',
        fontSize : 11,
        border : 'none'
    }
})

class IFC extends Component {
    state = {
        loading_data : false,
        loading_data_error : false,
        loading_data_error_message : null,
        models : [],
        selectedRowIndex : null,
        drl_url : null,
        selected_ic : null,
        global_field_display_name : null,
        group_display_name : null,
        field_display_name : null,
        open_generate_group_params : false,
        generating_groups : false,
        generating_groups_error : false,
        generating_groups_error_message : "",
        loading_versions : false,
        loading_versions_error : false,
        versions : null,
        report_version : 1,
        show_report : false,
        global_schema_IU : null,
        clustering_threshold : 0,
        value_weight : 0,
        historical_mappings : null,
        use_conflict_scores : true,
    }

    componentDidMount () {
        Actions('http_request', {
            url : "/sainapse/data_rendering_service",
            method : 'get',
            data : {}
        }).then(res => {
            this.setState({...this.state, drl_url : res.data.result[0].url}, () => this.getIFCICs())
        })
    }

    getIFCICs = () => {
        this.setState({...this.state, loading_data : true}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let all_ics = res.data.result
                let dedup_ics = all_ics.filter(ic => ic.operations.includes("IFC"))
                this.setState({...this.state, loading_data : false, models : dedup_ics, loading_data_error : false, loading_data_error_message : null}, () => console.log("Dedup State :", this.state))
            }).catch(err => {
                this.setState({...this.state, loading_data : false, loading_data_error : true, loading_data_error_message : "Error in getting Dedup ICs."})
            })
        })
    }

    renderReport = () => {
        if (this.state.report_ic_name !== null && this.state.report_version !== null) {
            if (this.state.show_report) {
                return (
                    <Report 
                        ic_name = {this.state.selected_ic} 
                        version = {this.state.report_version}
                        global_field_display_name = {this.state.global_field_display_name}
                        group_display_name = {this.state.group_display_name}
                        field_display_name = {this.state.field_display_name}
                        close_report = {this.closeReport} 
                        close_n_complete = {(ic_name, version) => {
                            this.setState({...this.state, show_report : false, report_version : null}, () => {
                            this.completeReview(ic_name, version)
                        })
                    }}/>
                )
            }
        }
    }

    closeReport = () => {
        this.setState({...this.state, show_report : false, report_version : null})
    }

    renderIFCs = () => {
        return (
            <div style = {{width  : '100%', height : 'calc(100vh - 50px)'}}>
                <Paper variant = 'outlined' square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{fontSize : 20, fontWeight : 600}} variant = 'h6'>Intelligent Field Consolidation</Typography>
                </Paper>
                <div style = {{width : '100%', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row'}}>
                    <div style = {{width : '30%', height : '100%'}}>
                        {this.state.loading_data ? 
                        <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <CircularProgress variant = 'determinate' color = 'primary'/>
                        </div> : this.renderICs()}
                    </div>
                    <div style = {{width : '70%', height : '100%'}}>
                        {this.state.selected_ic !== null ? this.renderVersions() : null}
                    </div>
                </div>
            </div>
        );
    }

    renderICs = () => {
        const { classes } = this.props
        return (
            <div style = {{width : '100%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography variant = 'subtitle2'>Information Channels</Typography>
                </Paper>
                <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                    <TableContainer
                        style = {{
                            width : '100%',
                            maxHeight : '100%'
                        }}
                    >
                        <Table
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        // className = {classes.headerStyle}
                                    >Name</TableCell>
                                    <TableCell
                                        // className = {classes.headerStyle}
                                    >Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.models.map(model => {
                                    return (
                                        <TableRow 
                                            style = {{width : '100%', backgroundColor : this.state.selected_ic === model.name ? '#EBF7FF' : '#FFFFFF', cursor : 'pointer'}}
                                            onClick = {() => {
                                                let global_field_display_name = model.world_view.configs.find(config => config.operation === "IFC").config_params.global_field_display_name
                                                let group_display_name = model.world_view.configs.find(config => config.operation === "IFC").config_params.group_display_name
                                                let field_display_name = model.world_view.configs.find(config => config.operation === "IFC").config_params.field_display_name

                                                this.setState(
                                                    {
                                                        ...this.state, 
                                                        selected_ic : this.state.selected_ic === model.name ? null : model.name,
                                                        global_field_display_name : global_field_display_name,
                                                        group_display_name : group_display_name,
                                                        field_display_name : field_display_name,
                                                        generating_groups_error : false,
                                                        generating_groups_error_message : ""
                                                    }, () => this.getVersions())
                                                }}
                                        >
                                            <TableCell>{model.name}</TableCell>
                                            <TableCell>{this.renderDedupOperationStatus(model)}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        )
    }

    getVersions = () => {
        if (this.state.selected_ic !== null) {
            console.log("IFC :: Global Field Display Name : ", this.state.global_field_display_name)
            this.setState({...this.state, loading_versions : true, loading_versions_error : false}, () => {
                Actions('http_request', {
                    url : "/sainapse/ifc/version_info",
                    method : "post",
                    data : {
                        ic_name : this.state.selected_ic
                    }
                }).then(res => {
                    console.log("IFC :: Report Versions : ", res.data.result)
                    this.setState({...this.state, loading_versions : false, loading_versions_error : false, versions: res.data.result.Result})
                }).catch(err => {
                    this.setState({...this.state, loading_versions : false, loading_versions_error : true, versions: null})
                })
            })
        }
    }

    renderDedupOperationStatus = (ic_data) => {
        let ic_op = ic_data.operations.filter(op => op === "IFC")
        let operation = ic_op.map(op =>  <TrainingStage size = 'small' ic = {ic_data} op = {op} refresh = {this.getDedupeICs} interaction = {false}/>)
        console.log('IC OP :', operation)
        return operation
    }

    renderVersions = () => {
        return (
            <div style = {{width : '100%', height : '100%' }}>
                <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>IFC Report Versions</Typography>
                    {!this.state.open_generate_group_params && <Button
                        variant = 'contained'
                        size = 'small'
                        color = 'primary'
                        disabled = {this.state.open_generate_group_params}
                        onClick = {() => this.setState({...this.state, open_generate_group_params: !this.state.open_generate_group_params})}
                    >
                        Generate Groups
                    </Button>}
                </Paper>
                <Collapse in = {this.state.open_generate_group_params}>
                    <Paper square elevation = {0} style = {{width : '100%'}}>
                        {this.state.versions && <div style = {{width : '100%', height : '50px', padding : '10px', borderBottom: '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography variant = 'caption' color = 'secondary'>Generating Groups will clear all previous versions</Typography>
                        </div>}
                        <div style = {{width : '100%', height : '50px',borderBottom: '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px'}}>
                            <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Parameters to generate groups</Typography>
                            <IconButton size = 'small' color = 'secondary' onClick = {() => this.setState({...this.state, 
                                open_generate_group_params : false,
                                global_schema_IU : null,
                                clustering_threshold : 0,
                                value_weight : 0
                            })}>
                                <Clear fontSize = 'inherit'/>
                            </IconButton>
                        </div>
                        <div style = {{width : '100%', padding : '10px', display : 'flex', flexFirection : 'row', alignItems: 'center', alignContent : 'flex-start'}}>
                            {/* <div style = {{width : '33%', padding : '10px', marginTop: '10px'}}>
                                <div style = {{width : '100%', height : '75px'}}>
                                    <FormControl fullWidth>
                                        <InputLabel>Global Field IU</InputLabel>
                                        <Select
                                            value={this.state.global_schema_IU}
                                            onChange={(event) => this.setState({...this.state, global_schema_IU : event.target.value})}
                                        >
                                            {this.state.models.find(model => model.name === this.state.selected_ic).information_units.map(iu => {
                                                return (
                                                    <MenuItem value = {iu.name}>{iu.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style = {{width : '100%', height : '50px'}}>
                                    <Typography variant = 'caption' color = 'textSecondary'>Select the IU containing global fields.</Typography>
                                </div>
                            </div> */}
                            <div style = {{width : '33%', padding : '10px', marginTop: '10px'}}>
                                <div style = {{width : '100%', height : '75px'}}>
                                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'body2'>Clustering Threshold</Typography>
                                        <Typography variant = 'subtitle2' color = 'primary'>{this.state.clustering_threshold}</Typography>
                                    </div>
                                    <Slider 
                                        value = {this.state.clustering_threshold} 
                                        onChange = {(event, newValue) => this.setState({...this.state, clustering_threshold: newValue})} 
                                        style = {{width : '100%', marginRight : '10px'}}
                                        valueLabelDisplay="auto"
                                        min = {0}
                                        max = {1}
                                        step = {0.01}
                                    />
                                </div>
                                <div style = {{width : '100%', height : '50px'}}>
                                    <Typography variant = 'caption' color = 'textSecondary'>Controls the quality of grouping. Higher value enforces grouping of highly similar fields and vice a versa.</Typography>
                                </div>
                            </div>
                            <div style = {{width : '33%', padding : '10px', marginTop: '10px'}}>
                                <div style = {{width : '100%', height : '75px'}}>
                                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'body2'>Value Weight</Typography>
                                        <Typography variant = 'subtitle2' color = 'primary'>{this.state.value_weight}</Typography>
                                    </div>
                                    <Slider 
                                        value = {this.state.value_weight} 
                                        onChange = {(event, newValue) => this.setState({...this.state, value_weight: newValue})} 
                                        style = {{width : '100%', marginRight : '10px'}}
                                        valueLabelDisplay="auto"
                                        min = {0}
                                        max = {1}
                                        step = {0.01}
                                    />
                                </div>
                                <div style = {{width : '100%', height : '50px'}}>
                                    <Typography variant = 'caption' color = 'textSecondary'>The weight given for value-based similarity in computing similarity for a pair of fields.</Typography>
                                </div>
                            </div>
                        </div>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', padding : '10px', marginTop: '10px'}}>
                            <div style = {{width : '33%'}}>
                                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                    <Typography style = {{flexGrow : 1}} variant = 'body2'>Historical Mapping</Typography>
                                </div>
                                <TextField
                                    placeholder = "Historical Mappings"
                                    helperText = "Path the historical map file"
                                    fullWidth
                                    value = {this.state.historical_mappings}
                                    onChange = {(event) => this.setState({...this.state, historical_mappings : event.target.value === "" ? null : event.target.value})}
                                />
                            </div>
                            <div style = {{width : '33%', paddingLeft : '10px'}}>
                                {/* <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                    <Typography style = {{flexGrow : 1}} variant = 'body2'>Use Conflict Scores</Typography>
                                    <Switch
                                        color = 'primary'
                                        checked = {this.state.use_conflict_scores}
                                        onChange={(event) => this.setState({...this.state, use_conflict_scores : event.target.checked})}
                                    />
                                </div> */}
                            </div>
                        </div>
                        <div style = {{width : '100%', height : '50px', padding : '10px', marginTop : '10px', borderTop : '1px solid rgba(0,0,0,0.12)', borderBottom: '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center'}}>
                            <Button
                                variant = 'contained'
                                size = 'small'
                                color = 'primary'
                                onClick = {() => this.generateGroups()}
                            >
                                Generate Groups
                            </Button>
                            <Typography style = {{flexGrow : 1}} variant = 'capition' color = 'secondary'>{this.state.generating_groups_error_message}</Typography>
                        </div>
                    </Paper>
                </Collapse>
                {this.state.versions !== null && <div style = {{width : '100%', height : 'calc(100% - 50px)'}}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Version</TableCell>
                                    <TableCell>User ID</TableCell>
                                    <TableCell>Source Version</TableCell>
                                    <TableCell>Created On</TableCell>
                                    <TableCell>Completed On</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align = 'center'>Actions</TableCell>
                                    <TableCell>Consolidation</TableCell>
                                    <TableCell>Download Report</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.versions.map(ver => {
                                    return (
                                        <TableRow>
                                            <TableCell>{ver.version}</TableCell>
                                            <TableCell>{ver.uid}</TableCell>
                                            <TableCell>{ver.source_version}</TableCell>
                                            <TableCell>{format(new Date(ver.creation_time), "yyyy-MM-dd HH:mm:ss.SSSxxx")}</TableCell>
                                            <TableCell>{ver.completion_time !== null ? format(new Date(ver.completion_time), "yyyy-MM-dd HH:mm:ss.SSSxxx") : null}</TableCell>
                                            <TableCell>{ver.status}</TableCell>
                                            <TableCell>{ver.status === 'Complete' ? 
                                                <Fragment>
                                                    <Button
                                                        size = 'small'
                                                        color = 'primary'
                                                        onClick = {() => this.createNewVersion(ver.version)}
                                                    >New Version</Button>
                                                    <Button
                                                        size = 'small'
                                                        color = 'secondary'
                                                        disabled = {ver.consolidation_status === "Pending" || ver.consolidation_status === "Complete"}
                                                        onClick = {() => this.consolidate(ver.version)}
                                                    >Consolidate</Button>
                                                </Fragment> :
                                                <Fragment>
                                                    <Button
                                                        size = 'small'
                                                        color = 'primary'
                                                        onClick = {() => this.reviewVersion(ver.version)}
                                                    >Review</Button>
                                                    <Button
                                                        size = 'small'
                                                        color = 'secondary'
                                                        onClick = {() => this.completeReview(this.state.selected_ic, ver.version)}
                                                    >
                                                        Complete
                                                    </Button>
                                                </Fragment>
                                            }</TableCell>
                                            <TableCell>
                                                {ver.consolidation_status !== 'Complete' ? 
                                                <>
                                                    <Typography variant = 'caption'>{ver.consolidation_status}</Typography>
                                                </> :
                                                <>
                                                    <Typography variant = 'subtitle2'>{ver.consolidation_status}</Typography>
                                                    <Typography variant = 'caption'>{format(new Date(ver.consolidation_timestamp), "yyyy-MM-dd HH:mm:ss.SSSxxx")}</Typography>
                                                </>}
                                            </TableCell>
                                            <TableCell>
                                            <ButtonGroup disabled = {ver.status === 'Complete' ? false : true} size = 'small' variant="contained" color="primary">
                                                <Button onClick = {() => this.downloadReport(ver.version, 'html')}>HTML</Button>
                                                <Button onClick = {() => this.downloadReport(ver.version, 'csv')}>CSV</Button>
                                                <Button onClick = {() => this.downloadReport(ver.version, 'excel')}>Excel</Button>
                                            </ButtonGroup>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>}
            </div>
        )
    }

    completeReview = (ic_name, version) => {
        Actions('http_request', {
            url : "/sainapse/ifc/review_complete",
            method : "post",
            data : {
                ic_name : ic_name,
                version : version
            }
        }).then(res=> {
            this.getVersions()
        })
    }

    createNewVersion = (version) => {
        Actions('http_request', {
            url : "/sainapse/ifc/review_start",
            method : "post",
            data : {
                ic_name : this.state.selected_ic,
                source_version : version
            }
        }).then(res => {
            this.getVersions()
        })
    }

    consolidate = (version) => {
        Actions('http_request', {
            url : "/sainapse/ifc/consolidate",
            method : "post",
            data : {
                // drop_merged : true,
                ic_name: this.state.selected_ic,
                version : version
            }
        }).then(res => {
            this.getVersions()
        })
    }

    downloadReport = (version, format) => {
        Actions('http_request', {
            url : this.state.drl_url + "/drl/ifc/report",
            method : '',
            data : {},
            params : {
                ic_name : this.state.selected_ic,
                version : version,
                format : format
            }
        }).then(res => {
            console.log("IFC :: DRL Response : ", res.data)
            Actions('http_request', {
                url : this.state.drl_url + "/" + res.data.file_link,
                method : 'get',
                responseType : 'blob'
            }).then(response => {
                console.log("Download Response : ", res)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', res.data.file_link); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        }).catch(err => {

        })
    }

    reviewVersion = (version) => {
        this.setState({...this.state, report_version : version, show_report : true })
    }

    generateGroups = () => {
        this.setState({...this.state, generating_groups : true, generating_groups_error : false, generating_groups_error_message : ""}, () => {
            Actions("http_request", {
                url : "/sainapse/ifc/generate_groups",
                method : "post",
                data : {
                    // global_schema_IU : this.state.global_schema_IU,
                    clustering_threshold : this.state.clustering_threshold,
                    ic_name : this.state.selected_ic,
                    use_conflict_scores : this.state.use_conflict_scores,
                    historical_mappings : this.state.historical_mappings,
                    value_weight: this.state.value_weight
                }
            }).then(res => {
                this.setState({...this.state, open_generate_group_params: false, clustering_threshold : 0, value_weight : 0}, () => this.getVersions())
            }).catch(err => {
                this.setState({...this.state, generating_groups : false, generating_groups_error : true, generating_groups_error_message : err.response.data.message})
            })
        })
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.state.show_report ? this.renderReport() : this.renderIFCs()}
            </ThemeProvider>
        )
    }
}
 
export default withStyles(styles)(IFC);